import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tw-group tw-relative tw-inline-flex" }
const _hoisted_2 = ["id", "name", "disabled", "checked", "data-testid", "aria-label"]
const _hoisted_3 = {
  key: 0,
  role: "tooltip",
  class: "tw-pointer-events-none tw-absolute tw-bottom-full tw-right-0 tw-mb-2 tw-hidden tw-w-max tw-max-w-[200px] tw-whitespace-normal tw-rounded tw-bg-gray-800 tw-px-2 tw-py-1 tw-text-xs tw-text-white group-hover:tw-block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("input", {
      id: _ctx.id,
      name: _ctx.id,
      type: "checkbox",
      class: "tw-peer tw-sr-only",
      disabled: _ctx.disabled,
      checked: _ctx.checked,
      "data-testid": _ctx.id,
      "aria-label": _ctx.ariaLabel || undefined,
      onInput: _cache[0] || (_cache[0] = $event => _ctx.$emit('update:checked', $event))
    }, null, 40, _hoisted_2),
    _createElementVNode("div", {
      class: _normalizeClass(["tw-peer tw-h-6 tw-w-12 tw-rounded-full tw-bg-slate-300 after:tw-absolute after:tw-left-[2px] after:tw-top-[2px] after:tw-h-5 after:tw-w-5 after:tw-rounded-full after:tw-bg-white after:tw-transition-all after:tw-content-[''] peer-checked:tw-bg-black peer-checked:after:tw-translate-x-6 peer-focus:tw-ring-2 peer-focus:tw-ring-deep-orange-600 dark:tw-bg-slate-400 after:dark:tw-bg-black", {
        'tw-cursor-pointer': !_ctx.disabled,
        'tw-cursor-not-allowed !tw-bg-slate-200 peer-checked:tw-bg-deep-orange-300 dark:!tw-bg-slate-700': _ctx.disabled
      }])
    }, null, 2),
    (_ctx.disabled && _ctx.disabledReason)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.disabledReason), 1))
      : _createCommentVNode("", true)
  ]))
}